import * as React from "react";
import { LinearProgress } from "@mui/material";
import { withStyles } from "@mui/styles";
const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: "16px !important",
    borderRadius: 20,
    width: "86%",
    margin: "20px 0px",
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 20,
    background: "linear-gradient(180deg, #EEBE62 0%, #9C702A 100%)",
  },
}))(LinearProgress);

export default function Progress() {
  return (
    <>
      <BorderLinearProgress variant="determinate" value={50} />
    </>
  );
}
